import React, {Component} from 'react';
import Relay from 'react-relay';
import NavbarLogin from '../../components/navbarLogin'

// import AddConversationMutation from '../../mutations/AddConversationMutation';

export default class SignUp extends Component{

  constructor(props)
  {
    super(props);
    this.state={em:false,pwd:false};
    this.validateEmail=this.validateEmail.bind(this);
    this.pwdCheck=this.pwdCheck.bind(this);
    this.sendData=this.sendData.bind(this);

  }

  validateEmail() {
      var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      this.setState({em:re.test(this.refs.email.value.trim())});
  }

  pwdCheck()
  {
    var pd=this.refs.pwrd.value.trim();
    if(pd==""){
      this.setState({pwd:false});
    }
    else {
      this.setState({pwd:true});
    }
  }

  sendData()
  {
    console.log(this.props.info);
    console.log(this.refs.email.value);
    console.log(this.refs.pwrd.value);

    var date = new Date();
    
    if (this.props.info.startDate == "1 week"){
      date.setDate(date.getDate() + 7);
    }
    else if (this.props.info.startDate == "2 weeks"){
      date.setDate(date.getDate() + 14);
    }
    else if (this.props.info.startDate == "1 month"){
      date.setMonth(date.getMonth() + 1);
    }
    else if (this.props.info.startDate == "2 months"){
      date.setMonth(date.getMonth() + 2);
    }

    var params = JSON.stringify({
      "email": this.refs.email.value,
      "password": this.refs.pwrd.value,
      "respondents": this.props.info.repondents,
      "projectTitle": this.props.info.proj_name,
      "startDate": date.toISOString()
    });
    var url = 'http://surveymate-io.herokuapp.com/api/users/signUp';
    var responseCode;

    var response = fetch(url, {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
      },
      body: params
    }).then(function (response) {
        responseCode = response.status;
        return response.text();
    }).then(function (result) {
        var jsonData = JSON.parse(result);
        if (responseCode == 200) {
          document.cookie = "access_token ="+jsonData.id;
          document.cookie = "userId ="+jsonData.userId;

          window.location.href='/#/projects/' + jsonData.userId;
        }
        else {
          alert(jsonData.error.message);
        }
    }).catch(function (error) {
      console.error('An error occured');
      console.error(error);
    });
  }

  render ()
  {

    var  eclass,btn1class,btn2class;
    var st={
        pro:{
        width:"100%",
        backgroundColor:"#1a84eb",
      },
      pro_h:{
        height:"9px",
        borderRadius: "2px",
      },

      in:{
        height: "50px",
        borderRadius: "5px",
      },
      small_:{
        opacity: 0.5,
         fontSize: "12px",
         letterSpacing: "0.3px",
         color: "#000000",
      },
      bttn_attri:{
        height:"44px",
        backgroundColor:"#1a84eb",
        border:"none"

      },

      prev_attri:{
        textDecoration:"none",
        color:"#000000",
        border:"none"
      },
      or_:{
        paddingTop:"10px",
      }
    }

    if(this.state.em)
    {
      eclass="form-group has-success"
    }
    else {
      eclass="form-group has-error"
    }
    if(this.state.em && this.state.pwd)
    {
      btn1class="btn btn-info btn-lg pull-left col-md-5";
      btn2class="btn btn-info  btn-lg pull-right col-md-5";
      st.bttn_attri.backgroundColor="#1a84eb";
    }
    else {
      btn1class="btn btn-info btn-lg pull-left col-md-5 disabled";
      btn2class="btn btn-info  btn-lg pull-right col-md-5 disabled";
      st.bttn_attri.backgroundColor="#d1d1d1";
    }

      return (
        <div>
        <div>
          <NavbarLogin />
        </div>
        <div className="row">
          <div className="col-md-5"></div>
          <div className="col-md-2">
            <div className="col-md-7" style={st.small_}>
              STEP 2 OF 2
            </div>
            <div className="col-md-5">
            <div className="progress"style={st.pro_h}>
              <div className="progress-bar" role="progressbar" aria-valuenow="70" aria-valuemin="0" aria-valuemax="100" style={st.pro}>
                <span className="sr-only"></span>
              </div>
            </div>
            </div>
          </div>
        <div className="col-md-5"></div>
        </div>
        <div>
          <h1 className="text-center">Create your account</h1>
        </div>

        <div className="row">
        <div className="col-md-2"></div>
        <div className="col-md-8">

          <form role="form">
            <div className={eclass} >
              <label htmlFor="usr">EMAIL</label>
              <input type="text" className="form-control" id="usr" style={st.in} placeholder="Enter E-mail address" ref="email" onChange={this.validateEmail}/>
            </div>
            <div className="form-group">
              <label htmlFor="sel1">PASSWORD</label>
              <input type="password" className="form-control" id="usr" style={st.in} onChange={this.pwdCheck} ref="pwrd"/>
            </div>

          </form>
        </div>

        <div className="col-md-2"></div>
        </div>
        <br />
        <br />
        <br />

        <div className="row">
          <div className="col-md-2"></div>
          <div className="col-md-8">
             
              <div className="col-md-7">
                <div className="row">
                  <a className={btn2class} style={st.bttn_attri} onClick={this.sendData}><small>CONTINUE TO CHAT</small>
                    <small><span className="glyphicon glyphicon-menu-right glyphicon"></span></small>
                  </a>
                  </div>
              </div>
            </div>
          <div className= "col-md-2"></div>
        </div>


        </div>
      );
  }
}



/** WEBPACK FOOTER **
 ** ./src/views/Register/SignUp.js
 **/